import React, { useState, useEffect } from 'react'
import {
  TextField,
  Grid,
  Button,
  MenuItem,
  Card,
  CardContent,
  Typography
} from '@material-ui/core'
import DimensionsListInPage from './dimensionsCrossdoc'
import RonadIcons from '../../iconComponent'
import getValidPackages from 'client-sdk/src/orders/getValidPackages'

const DimensionInputs = (props: any) => {
  const [validPackages, setValidPackages] = useState([])
  const [weight, setWeight] = useState('')
  const [code, setCode] = useState('')
  const [objectPackage, setObjectPackage] = useState<any>({})

  const checkButtonDisabled = () => {
    return !code || !weight
  }

  const { setDimensions, dimensions, editMode } = props

  const addDimensions = () => {
    const { id, ...newObjectPackage } = objectPackage
    const newDimension = {
      id: Date.now(),
      totalWeight: weight,
      packageCode: code,
      ...newObjectPackage
    }

    setDimensions([...dimensions, newDimension])
    setCode('')
    setWeight('')
  }

  const handlerInfoPackage = (e: any) => {
    const id = e.target.value
    setCode(id)
    const selectedItem = validPackages.find((item: any) => item.id === id)
    setObjectPackage(selectedItem)
  }

  useEffect(() => {
    const handlerFetchCenterList = async () => {
      try {
        const response = await getValidPackages()
        if (response.ok) {
          setValidPackages(response.response)
        }
      } catch (error) {
        console.error('خطا در دریافت اطلاعات:', error)
      }
    }
    handlerFetchCenterList()
  }, [])

  return (
    <Card style={{ marginBottom: '24px', marginTop: '24px' }}>
      <CardContent>
        <Grid container spacing={2} justifyContent='flex-start'>
          {!editMode && (
            <>
              <Grid item xs={5}>
                <TextField
                  variant='outlined'
                  select
                  fullWidth
                  value={code}
                  label='سایز بسته‌بندی'
                  onChange={handlerInfoPackage}
                >
                  {validPackages.map((item: any) => (
                    <MenuItem value={item.id}>{item.name}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={5}>
                <TextField
                  variant='outlined'
                  fullWidth
                  id='weight'
                  name='weight'
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                  label='وزن بسته'
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  style={{ height: '100%' }}
                  variant='outlined'
                  color='primary'
                  size='large'
                  onClick={addDimensions}
                  disabled={checkButtonDisabled()}
                  startIcon={
                    <RonadIcons
                      name='plusCircleOutline'
                      className='text-primary'
                    />
                  }
                  id='addProduct'
                >
                  {'افزودن بسته به سفارش'}
                </Button>
              </Grid>
            </>
          )}
          {dimensions?.length !== 0 && (
            <Grid item xs={12}>
              <DimensionsListInPage
                setDimensions={setDimensions}
                data={dimensions}
                editMode={editMode}
                modal
              />
            </Grid>
          )}
          {!editMode && (
            <Grid container className='notif'>
              <RonadIcons
                name='information'
                size={0.7}
                style={{ color: '#43778E' }}
              />
              <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                وارد کردن اندازه بسته‌ها در روش ارسال مستقیم اجباری است.
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  )
}

export default DimensionInputs
